import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import * as FilterStateActions from './state.actions';
import { LogbooksService } from '../../logbooks/logbooks.service';
import { ServiceUtilities } from '../../../shared/helper/service-utilities';
import { IGetManyResponse } from '../../../shared/model/interface/crud-response-interface.model';
import { IStates } from '../../logbooks/logbooks.model';

@Injectable()
export class FilterStateEffects {
  constructor(
    private readonly actions$: Actions<FilterStateActions.FilterStateActions>,
    public service: LogbooksService,
  ) {}

  loadFilterStates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FilterStateActions.START_LOAD_FILTER_STATES),
      switchMap(() => {
        const httpParams: HttpParams = ServiceUtilities.prepareGenericHttpParamsForRequest({
          sort: { type: '', column: 'name' },
          limit: 5000,
          offset: 0,
        });

        return this.service.getStateListData(httpParams).pipe(
          switchMap((response: IGetManyResponse<IStates>) => {
            return of(new FilterStateActions.FilterStatesLoaded(response.data ?? []));
          }),
          catchError(() => {
            return of(new FilterStateActions.FilterStatesLoaded([]));
          }),
        );
      }),
    ),
  );
}
